import { Injectable } from "@angular/core";
import { lastValueFrom } from "rxjs";
import { BaseSessionService } from "@apps/patient-core/src/app/services/abstracts/session.service";

@Injectable({
  providedIn: "root",
})
export class ConciergeSessionService extends BaseSessionService {
  public async init(): Promise<void> {
    return lastValueFrom(this._getSession()).then(); // Call get session because this is the only XHR call which will return the server time
  }

  public onPageUnload(): void {
    // Do nothing (defined in parent class as abstract)
  }
}
